import { __decorate } from "tslib";
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { getlibrariesAll } from '@blade-sxp/monitor/api/monitor-management/portrait';
let default_1 = class default_1 extends Vue {
    detail;
    librariesAll = [];
    formData = { matchThreshold: 0, libraryIds: [] };
    onTaskDetailChange(val) {
        this.getIds();
        console.log('form data:', this.detail);
    }
    getlibrariesAll() {
        getlibrariesAll()
            .then((resp) => {
            this.librariesAll = resp.data.data.list;
            console.log('res:', this.librariesAll);
        })
            .catch((err) => {
            this.$message({ type: 'error', message: err });
        });
    }
    async mounted() {
        await this.getlibrariesAll();
        // this.formData = { ...this.formData, ...this.detail };
        this.getIds();
    }
    getIds() {
        const removeDup = Array.from(new Set(this.detail.libraryIds || [])).map((item) => item.toString());
        this.formData.libraryIds = removeDup;
        this.formData.matchThreshold = this.detail.matchThreshold;
    }
};
__decorate([
    Prop()
], default_1.prototype, "detail", void 0);
__decorate([
    Watch('detail')
], default_1.prototype, "onTaskDetailChange", null);
default_1 = __decorate([
    Component({
        name: 'FaceAlarm',
    })
], default_1);
export default default_1;
